import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setselectedTab } from "../../../Store/B2bslice";
import { serviceCategory } from "../../../Utils";
import { AiFillCheckCircle, AiOutlineUser } from "react-icons/ai";
import { BiRefresh } from "react-icons/bi";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);
import {
  GetDashboardData,
  GetDashboardDT_MDData,
  GetDashboardSTATE_HEADData,
  getmemberFilterList,
  GetRecentTransactions,
  GetWalletBalance,
} from "../../../ApiServices/Apifun";

import {
  Card,
  Collapse,
  DatePicker,
  Image,
  Select,
  Skeleton,
  Spin,
  Switch,
  Table,
} from "antd";
import { MdCancel, MdPending } from "react-icons/md";
import { NavLink, useNavigate } from "react-router-dom";
import DashboardCommon from "./DashboardCommon";
import { CheckCircleFilled, InsertRowAboveOutlined } from "@ant-design/icons";
import {
  BsArrowDown,
  BsArrowUp,
  BsFileBarGraph,
  BsGraphUp,
} from "react-icons/bs";
import { Images } from "../../../Controller";
import { RiCrossFill } from "react-icons/ri";
import { FaCross } from "react-icons/fa6";
import dayjs from "dayjs";
import CommonPagination from "../../../Common/Pagination";
import { Bar } from "react-chartjs-2";
import { GrTransaction } from "react-icons/gr";
import { HiOutlineArrowDown, HiOutlineArrowUp } from "react-icons/hi2";
const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [cardData, setCardData] = useState({
    Total_txn: "",
    money_in: "",
    money_out: "",
    members: "",
  });
  const [memberOptions, setMemberOptions] = useState([]);
  const [memberTypeFilter, setMemberTypeFilter] = useState(null);
  const [spinState, setSpinState] = useState(false);
  const [collapsed, setCollapsed] = useState(["0"]);
  const [loader, setLoader] = useState(false);
  const [activeServices, setActiveServices] = useState([]);
  const [banners, setBanners] = useState([]);
  const [inActiveServices, setInactiveServices] = useState([]);
  const [accordionData, setAccordionData] = useState([]);
  const [MD_DT_Data, setMD_DTData] = useState([]);
  const [stateHEadData, setstateHEadData] = useState([]);
  const walletBalance = useSelector((state) => state.B2B.walletBal);
  const heading = useSelector((state) => state.B2B.heading);
  const memberService = useSelector((state) => state.B2B.memberServices);
  const profiledetail = useSelector((state) => state.B2B.profileDetail);
  const today = dayjs().format("YYYY-MM-DD");
  const [dataSource, setDataSource] = useState([]);
  const [showGraph, setShowGraph] = useState(false);
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [Balance, setBalance] = useState(null);
  const { RangePicker } = DatePicker;
  const [chartData, setChartData] = useState([]);
  useEffect(() => {
    dispatch(setselectedTab("1"));
    let active = [];
    let inactive = [];
    Object.entries(serviceCategory).map(([key, val]) => {
      if (memberService.includes(val)) {
        active = [...active, key];
      } else {
        inactive = [...inactive, key];
      }
    });
    setActiveServices(active);
    setInactiveServices(inactive);
    setBalance(walletBalance);
  }, [memberService, walletBalance]);

  const onOk = (value) => {
    if (!value || value.length !== 2) {
      setStartDate(null);
      setEndDate(null);
      return;
    }

    setStartDate(value[0].format("YYYY-MM-DD"));
    setEndDate(value[1].format("YYYY-MM-DD"));
  };

  const getDashboard = () => {
    setLoader(true);
    GetDashboardData(`?from_date=${startDate}&to_date=${endDate}`)
      .then((res) => {
        setBanners(res.banners);
        setDataSource(res.commission_earned);
        if (res?.services?.length > 0) {
          const service = res.services.map((s) => ({
            service: s.service_name,
            amount: s.total_amount,
            Success: Number(s.total_amount_success),
            Failed: Number(s.total_amount_failed),
            Pending: Number(s.total_amount_pending),
          }));
          setChartData(service);
        } else {
          setChartData([]);
        }

        setAccordionData(
          res.services.map((i, index) => {
            return {
              key: index,
              label: (
                <div className=" w-full gap-2 place-items-start">
                  {/* <img
                    src={i.icon}
                    className="w-10 h-10 bg-white  p-1 rounded-full"
                    alt="icon"
                  /> */}
                  <div className="text-xs col-span-2 font-medium w-full">
                    <p>{i.service_name}</p>
                    <p>Total amt: {i.total_amount} Rs.</p>
                  </div>
                </div>
              ),
              children: (
                <div className="text-xs font-bold leading-5 grid">
                  <div className=" shadow-lg mt-2 shadow-gray-400 rounded-md p-3 flex justify-around  items-center">
                    <p className=""> Success</p>
                    <p className="">
                      {i.total_transactions_success} (
                      {"₹" + " " + i.total_amount_success})
                    </p>
                    <AiFillCheckCircle
                      className="bg-white  shadow-black text-green-700"
                      size={25}
                    />
                  </div>
                  <div className=" shadow-lg mt-2 shadow-gray-400 rounded-md p-3 flex justify-around  items-center">
                    <p className=""> Pending</p>
                    <p className="">
                      {i.total_transactions_pending} (
                      {"₹" + " " + i.total_amount_pending})
                    </p>
                    <MdPending
                      className="bg-white  shadow-black text-yellow-700"
                      size={25}
                    />
                  </div>
                  <div className=" shadow-lg mt-2 shadow-gray-400 rounded-md p-3 flex justify-around  items-center">
                    <p className=""> Failed</p>
                    <p className="">
                      {i.total_transactions_failed} (
                      {"₹" + " " + i.total_amount_failed})
                    </p>
                    <MdCancel
                      className="bg-white  shadow-black text-red-700"
                      size={25}
                    />
                  </div>
                </div>
              ),
              // showArrow: false,
            };
          }),
        );
        setCardData({
          Total_txn: res.total_transactions,
          money_in: res.money_in,
          money_out: res.money_out,
          members: res.total_members,
        });
      })
      .catch((err) => console.log(err))
      .finally(() => setLoader(false));
  };
  const getMemberFilter = () => {
    getmemberFilterList()
      .then((res) =>
        setMemberOptions(
          res.data.map((i, index) => {
            return {
              label: i.display_text,
              value: i.id,
              key: i.id,
            };
          }),
        ),
      )
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    profiledetail.member_type !== "Retailer" && getMemberFilter();

    if (profiledetail.member_type_id === "1") {
      getDashboardState_Head();
    } else if (
      profiledetail.member_type_id === "2" ||
      profiledetail.member_type_id === "3"
    ) {
      getDashboardDT_MD();
    } else {
      getDashboard();
    }
  }, [profiledetail?.member_type, startDate, endDate, memberTypeFilter]);

  const getDashboardDT_MD = () => {
    setLoader(true);
    GetDashboardDT_MDData(
      `from_date=${startDate}&to_date=${endDate}&member_id=${memberTypeFilter}`,
    )
      .then((res) => {
        setMD_DTData(res.data);
      })
      .catch((err) => console.log(err))
      .finally(() => setLoader(false));
  };

  const getDashboardState_Head = () => {
    setLoader(true);
    GetDashboardSTATE_HEADData(
      `from_date=${startDate}&to_date=${endDate}&member_id=${memberTypeFilter}`,
    )
      .then((res) => {
        setstateHEadData(res.data?.service_wise_transactions);
        // setstateHEadData(
        //   res.data.services.map((i, index) => {
        //     return {
        //       key: index,
        //       label: (
        //         <div className=" w-full gap-2 place-items-start">
        //           <div className="text-xs col-span-2 font-medium w-full">
        //             <p>{i.service_name}</p>
        //           </div>
        //         </div>
        //       ),
        //       children: (
        //         <div className="text-xs font-bold leading-5 grid">
        //           <div className=" shadow-lg mt-2 shadow-gray-400 rounded-md p-3 flex justify-around  items-center">
        //             <p className=""> Total amount</p>
        //             <p className="">
        //               {i.total_transactions_success} (
        //               {"₹" + " " + i.total_amount})
        //             </p>
        //             <AiFillCheckCircle
        //               className="bg-white  shadow-black text-green-700"
        //               size={25}
        //             />
        //           </div>
        //         </div>
        //       ),
        //       // showArrow: false,
        //     };
        //   }),
        // );
      })
      .catch((err) => console.log(err))
      .finally(() => setLoader(false));
  };
  useEffect(() => {}, [collapsed]);
  const handleGet = () => {
    setSpinState(true);
    GetWalletBalance()
      .then((res) => {
        setBalance(res.balance);
        setSpinState(false);
      })
      .catch((err) => console.log(err));
  };
  const ReportColumn = [
    {
      title: "Service Name",
      dataIndex: "service_name",
      key: "service_name",
      render: (text) => {
        return (
          <>
            <p className=" text-center">{text}</p>
          </>
        );
      },
    },
    {
      title: "Commission Earned",
      dataIndex: "commission_earned",
      key: "commission_earned",
      render: (text) => <p className=" text-center">{text} Rs.</p>,
    },
  ];

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "top" },
    },
    scales: {
      y: {
        beginAtZero: true,
        stacked: false, // ❌ turn OFF stacking
        title: { display: true, text: "Count" }, // better label since it's count
      },
      x: {
        stacked: false, // ❌ turn OFF stacking
        ticks: {
          maxRotation: 90,
          minRotation: 45,
          autoSkip: false,
        },
      },
    },
  };

  const graphData = {
    labels: MD_DT_Data?.service_wise_transactions?.map(
      (item) => item.service_name,
    ),
    datasets: [
      {
        label: "Success",
        data: MD_DT_Data?.service_wise_transactions?.map(
          (item) => item.success.amount,
        ),
        backgroundColor: "#CABEF4",
        barPercentage: 0.8,
        categoryPercentage: 0.6,
      },
      {
        label: "Failed",
        data: MD_DT_Data?.service_wise_transactions?.map(
          (item) => item.failed.amount,
        ),
        backgroundColor: "#EBCBE7",
        barPercentage: 0.8,
        categoryPercentage: 0.6,
      },
      {
        label: "Pending",
        data: MD_DT_Data?.service_wise_transactions?.map(
          (item) => item.pending.amount,
        ),
        backgroundColor: "#C3D6E8",
        barPercentage: 0.8,
        categoryPercentage: 0.6,
      },
    ],
  };

  const options2 = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "top" },
    },
    scales: {
      y: {
        beginAtZero: true,
        stacked: false, // ❌ disable stacking
        title: { display: true, text: "Amount" },
      },
      x: {
        stacked: false, // ❌ disable stacking
        ticks: {
          maxRotation: 90,
          minRotation: 45,
          autoSkip: false,
        },
      },
    },
  };

  const graph2Data = {
    labels: chartData.map((item) => item.service),
    datasets: [
      {
        label: "Success",
        data: chartData.map((item) => item.Success),
        backgroundColor: "#CABEF4",
        barPercentage: 0.8,
        categoryPercentage: 0.6,
      },
      {
        label: "Failed",
        data: chartData.map((item) => item.Failed),
        backgroundColor: "#EBCBE7",
        barPercentage: 0.8,
        categoryPercentage: 0.6,
      },
      {
        label: "Pending",
        data: chartData.map((item) => item.Pending),
        backgroundColor: "#C3D6E8",
        barPercentage: 0.8,
        categoryPercentage: 0.6,
      },
    ],
  };

  const options3 = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "top" },
    },
    scales: {
      y: {
        beginAtZero: true,
        stacked: false, // ❌ no stacking
        title: { display: true, text: "Amount" },
      },
      x: {
        stacked: false, // ❌ no stacking
        title: { display: true, text: "Service" },
        ticks: {
          maxRotation: 90,
          minRotation: 45,
          autoSkip: false,
        },
      },
    },
  };

  const graphData3 = {
    labels: stateHEadData?.map((item) => item.service_name),
    datasets: [
      {
        label: "Success",
        data: stateHEadData?.map((item) => item.success.amount),
        backgroundColor: "#CABEF4",
        barPercentage: 0.8,
        categoryPercentage: 0.6,
      },
      {
        label: "Failed",
        data: stateHEadData?.map((item) => item.failed.amount),
        backgroundColor: "#EBCBE7",
        barPercentage: 0.8,
        categoryPercentage: 0.6,
      },
      {
        label: "Pending",
        data: stateHEadData?.map((item) => item.pending.amount),
        backgroundColor: "#C3D6E8",
        barPercentage: 0.8,
        categoryPercentage: 0.6,
      },
    ],
  };
  const [recentTransactions, setRecentTransactions] = useState([]);
  const handleGetRecentTransactions = () => {
    setSpinState(true);
    GetRecentTransactions()
      .then((res) => {
        if (res.status) {
          setRecentTransactions(res.transactions);
          setSpinState(false);
        }
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    handleGetRecentTransactions();
  }, []);
  return (
    <>
      {profiledetail.member_type_id === "1" ? (
        <div className=" relative animate-fade-in w-full text-center items-center rounded-3xl">
          <div className="flex items-end justify-end m-2 gap-4">
            <div className="w-1/4">
              {/* <p className={`required text-textGray mt-2`}>
                Select Member Type
              </p> */}
              <Select
                placeholder="Select member"
                value={memberTypeFilter}
                onChange={(val) => setMemberTypeFilter(val)}
                className="w-full mt-2"
                options={memberOptions}
              />
            </div>
            <RangePicker
              onChange={(value, dateString) => onOk(value, dateString)}
            />
          </div>{" "}
          <Spin spinning={loader}>
            <div className="bg-white  rounded-3xl mt-3 p-3 w-full">
              <div className="mt-4 gap-2">
                <Spin spinning={loader}>
                  {stateHEadData?.length > 0 ? (
                    <div
                      style={{
                        height: 400,
                      }}
                    >
                      <Bar data={graphData3} options={options3} />{" "}
                    </div>
                  ) : (
                    <p>No data</p>
                  )}
                </Spin>
              </div>
            </div>
          </Spin>
        </div>
      ) : profiledetail.member_type_id === "2" ||
        profiledetail.member_type_id === "3" ? (
        <div className=" relative animate-fade-in w-full text-center items-center rounded-3xl">
          <div className="flex items-end justify-end m-2 gap-4">
            <div className="w-1/4">
              {/* <p className={`required text-textGray mt-2`}>
                Select Member Type
              </p> */}
              <Select
                placeholder="Select member"
                value={memberTypeFilter}
                onChange={(val) => setMemberTypeFilter(val)}
                className="w-full mt-2"
                options={memberOptions}
              />
            </div>

            <RangePicker
              onChange={(value, dateString) => onOk(value, dateString)}
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            {loader ? (
              <div className="grid grid-cols-1 mt-2 sm:grid-cols-2 md:grid-cols-2 gap-5 place-items-center">
                {[1, 2, 3].map((i) => (
                  <div className="  h-[100px] w-full">
                    <Skeleton.Button
                      active={true}
                      size={200}
                      shape={"default"}
                      block={false}
                    />
                  </div>
                ))}
              </div>
            ) : (
              <div
                className={`grid grid-cols-1  gap-2 ${recentTransactions.length > 0 ? "h-32" : "h-auto"}`}
              >
                <div
                  style={{ boxShadow: "0 0 6px 0  rgba(0, 0, 0, 0.341)" }}
                  className="text-primary rounded-2xl text-xl w-full bg-white border-black p-2 "
                >
                  <div className="flex justify-start gap-4 items-center">
                    <BsArrowDown
                      size={52}
                      className="hover:animate-spin border-dashed cursor-pointer transition-all border-black font-extrabold bg-[#ffffff42] rounded-full p-4"
                    />
                    <div>
                      <p>{MD_DT_Data.money_in} ₹</p>
                      <p>Money In</p>
                    </div>
                  </div>
                </div>
                <div
                  style={{ boxShadow: "0 0 6px 0  rgba(0, 0, 0, 0.341)" }}
                  className="text-primary rounded-2xl text-xl w-full bg-white border-black p-2 "
                >
                  <div className="flex justify-start gap-4 items-center">
                    <BsArrowUp
                      size={52}
                      className="hover:animate-spin border-dashed cursor-pointer transition-all border-black font-extrabold bg-[#ffffff42] rounded-full p-4"
                    />
                    <div>
                      <p>{MD_DT_Data.money_out} ₹</p>
                      <p>Money Out</p>
                    </div>
                  </div>
                </div>
              </div>
            )}{" "}
            <div
              className={`bg-white ${recentTransactions.length > 0 ? "h-[500px]" : "h-auto"}  overflow-y-scroll rounded-3xl p-3 `}
            >
              <div className="flex justify-start items-center gap-4">
                {/* <p className="bg-primary w-4 h-4 rounded-md"></p> */}
                <GrTransaction className="text-2xl " />
                <p className="font-bold">Recent Transactions</p>
                <BiRefresh
                  onClick={handleGetRecentTransactions}
                  className={`${spinState ? "animate-spin" : ""}`}
                  size={20}
                />
              </div>
              {recentTransactions.length > 0 ? (
                recentTransactions.map((transaction, index) => (
                  <Card
                    key={index}
                    className="mt-2 shadow-[0px_2px_2px_#ccdcff] rounded-xl "
                  >
                    <div className=" grid sm:grid-cols-1 md:grid-cols-[10%_60%_30%] sm:gap-2 md:gap-0 items-center">
                      <div>
                        {transaction.amount_type === "Cr" ? (
                          <HiOutlineArrowUp className="text-xl text-green-500" />
                        ) : (
                          <HiOutlineArrowDown className="text-xl text-red-500" />
                        )}{" "}
                      </div>
                      <div>
                        {" "}
                        <p className="text-black text-sm font-medium">
                          {transaction.service_name}
                        </p>
                        <p className="text-gray-500 text-xs">
                          {transaction.transaction_id}
                        </p>
                        <p className="text-gray-500 text-xs mt-2 font-medium">
                          {transaction.transaction_date}
                        </p>
                      </div>
                      <div>
                        {" "}
                        <p className="text-black text-sm font-medium">
                          {transaction.amount_type === "Cr" ? "+" : "-"}{" "}
                          {transaction.amount}
                        </p>
                        <p className="text-black text-xs">
                          {transaction.status === "0" ? (
                            <Tag color="warning">Pending</Tag>
                          ) : transaction.status === "1" ? (
                            <Tag color="success">Success</Tag>
                          ) : (
                            <Tag color="error">Failed</Tag>
                          )}
                        </p>
                      </div>
                    </div>
                  </Card>
                ))
              ) : (
                <p className="text-rgbaprimary7 text-sm">
                  No recent transactions
                </p>
              )}
            </div>
          </div>
          <Spin spinning={loader}>
            <div className="bg-white  rounded-3xl mt-3 p-3 w-full">
              <div className="flex justify-start mt-6 mb-2">
                {" "}
                <Switch
                  className="custom-switch "
                  checked={showGraph}
                  onChange={() => {
                    setShowGraph(!showGraph);
                  }}
                  size="small"
                  checkedChildren="Product Sale"
                  unCheckedChildren="My Earnings"
                />
              </div>
              {!showGraph ? (
                <>
                  {/* <div className="flex justify-center items-center gap-4 m-2">
                    <p className="font-medium text-xl  underline underline-offset-2">
                      Active Services Commission Earned
                    </p>
                  </div> */}

                  <Table
                    scroll={{ y: 55 * 5 }}
                    className="history-table sticky_header  animate-fade-in max-h-[350px]  overflow-x-auto text-white rounded-lg"
                    columns={ReportColumn}
                    pagination={false}
                    dataSource={MD_DT_Data.commission_earned}
                  />
                </>
              ) : (
                <Spin spinning={loader}>
                  {MD_DT_Data?.service_wise_transactions.length > 0 ? (
                    <div
                      style={{
                        // width: "100%",
                        // minWidth: 800,
                        // overflowX: "auto",
                        height: 400,
                      }}
                    >
                      <Bar data={graphData} options={options} />{" "}
                    </div>
                  ) : (
                    <p>No data</p>
                  )}
                </Spin>
              )}
              {/* {MD_DT_Data.commission_earned?.map((i, id) => {
                  return (
                    <Card
                      key={id}
                      title={
                        <p className="text-sm text-rgbaprimary7">
                          {i.service_name}
                        </p>
                      }
                      className="shadow-md"
                      bodyStyle={{ padding: "2px" }}
                    >
                      <p className="text-base text-green-600">
                        ₹ {i.commission_earned}
                      </p>
                    </Card>
                  );
                })}{" "} */}
            </div>
          </Spin>
        </div>
      ) : profiledetail.member_type_id === "4" ? (
        <>
          {" "}
          {/* <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 place-items-start gap-3">
            <div className="shadow-[0px_2px_2px_#ccdcff] p-2  bg-gradient-to-tr  from-green-500 via-green-500 to-green-600 h-20 grid grid-cols-2  w-full rounded-xl cursor-pointer">
              <CheckCircleFilled className="flex justify-start text-4xl m-auto items-start  text-white" />

              <p className="text-white text-lg leading-5 font-bold mt-4">
                Success
              </p>
            </div>
            <div className="shadow-[0px_2px_2px_#ccdcff] p-2  bg-gradient-to-tr  from-orange-500 via-orange-500 to-orange-600 h-20 grid grid-cols-2  w-full rounded-xl cursor-pointer">
              <MdPending className="flex justify-start text-4xl m-auto items-start  text-white" />
              <p className="text-white text-lg leading-5 font-bold mt-4">
                Pending
              </p>
            </div>
            <div className="shadow-[0px_2px_2px_#ccdcff] p-2  bg-gradient-to-tr  from-red-500 via-red-500 to-red-600 h-20 grid grid-cols-2  w-full rounded-xl cursor-pointer">
              <MdCancel className="flex justify-start text-4xl m-auto items-start  text-white" />
              <p className="text-white text-lg leading-5 font-bold mt-4">
                Failed
              </p>
            </div>
            <div className="shadow-[0px_2px_2px_#ccdcff] p-2  bg-gradient-to-tr  from-yellow-500 via-yellow-500 to-yellow-600 h-20 grid grid-cols-2  w-full rounded-xl cursor-pointer">
              <BsGraphUp className="flex justify-start text-4xl m-auto items-start  text-white" />
              <p className="text-white text-lg leading-5 font-bold mt-4">
                Total
              </p>
            </div>
          </div> */}
          <RangePicker
            onChange={(value, dateString) => onOk(value, dateString)}
          />
          <DashboardCommon />
          {loader ? (
            <div className="grid grid-cols-1 mt-2 sm:grid-cols-2 md:grid-cols-2 gap-5 place-items-center">
              {[1, 2, 3].map((i) => (
                <div className="  h-[100px]   w-full">
                  <Skeleton.Button
                    active={true}
                    size={200}
                    shape={"default"}
                    block={false}
                  />
                </div>
              ))}
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-3 mt-2 gap-2">
              <div
                style={{ boxShadow: "0 0 6px 0  rgba(0, 0, 0, 0.341)" }}
                className="text-primary rounded-2xl text-xl w-full bg-white border-black p-2 "
              >
                <div className="flex justify-start gap-4 items-center">
                  <InsertRowAboveOutlined
                    size={52}
                    className="hover:animate-spin border-dashed cursor-pointer transition-all border-black font-extrabold bg-[#ffffff42] rounded-full p-4"
                  />
                  <div>
                    <p>{cardData.Total_txn}</p>
                    <p>Total Txn</p>
                  </div>
                </div>
              </div>
              <div
                style={{ boxShadow: "0 0 6px 0  rgba(0, 0, 0, 0.341)" }}
                className="text-primary rounded-2xl text-xl w-full bg-white border-black p-2 "
              >
                <div className="flex justify-start gap-4 items-center">
                  <BsArrowDown
                    size={52}
                    className="hover:animate-spin border-dashed cursor-pointer transition-all border-black font-extrabold bg-[#ffffff42] rounded-full p-4"
                  />
                  <div>
                    <p>{cardData.money_in} ₹</p>
                    <p>Money In</p>
                  </div>
                </div>
              </div>
              <div
                style={{ boxShadow: "0 0 6px 0  rgba(0, 0, 0, 0.341)" }}
                className="text-primary rounded-2xl text-xl w-full bg-white border-black p-2 "
              >
                <div className="flex justify-start gap-4 items-center">
                  <BsArrowUp
                    size={52}
                    className="hover:animate-spin border-dashed cursor-pointer transition-all border-black font-extrabold bg-[#ffffff42] rounded-full p-4"
                  />
                  <div>
                    <p>{cardData.money_out} ₹</p>
                    <p>Money Out</p>
                  </div>
                </div>
              </div>
              {profiledetail.member_type !== "Retailer" ? (
                <div className="text-bswhite rounded-2xl text-xl w-full bg-[#e36532] border-black p-8 ">
                  <div className="flex justify-start gap-4 items-center">
                    <AiOutlineUser
                      size={52}
                      className=" border-dashed cursor-pointer transition-all border-black font-extrabold bg-[#ffffff42] rounded-full p-4"
                    />
                    <div>
                      <p>{cardData.members}</p>
                      <p>Members</p>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          )}
          <div className="grid grid-cols-1  gap-2">
            {/* <Spin spinning={loader}>
              <div className="bg-white  rounded-3xl mt-3 p-3 w-full">
                <div className="flex justify-start items-center gap-4">
                  <p className="bg-primary w-4 h-4 rounded-md"></p>
                  <p className="font-bold">Active Services</p>
                </div>

                <Collapse
                  className="grid grid-cols-1 md:grid-cols-3 gap-2 h-[300px]  overflow-y-scroll"
                  onChange={(val) => setCollapsed(val)}
                  // defaultActiveKey={["0"]}
                  ghost
                  items={accordionData}
                />
              </div>
            </Spin> */}
            <div>
              <div className="flex justify-start mt-6 mb-2">
                {" "}
                <Switch
                  className="custom-switch "
                  checked={showGraph}
                  onChange={() => {
                    setShowGraph(!showGraph);
                  }}
                  size="small"
                  checkedChildren="Product Sale"
                  unCheckedChildren="My Earnings"
                />
              </div>

              {!showGraph ? (
                <Spin spinning={loader}>
                  <Table
                    scroll={{ y: 55 * 5 }}
                    className="history-table sticky_header  animate-fade-in max-h-[350px]  overflow-x-auto text-white rounded-lg"
                    columns={ReportColumn}
                    pagination={false}
                    dataSource={dataSource}
                  />
                </Spin>
              ) : (
                <Spin spinning={loader}>
                  {chartData.length > 0 ? (
                    <div
                      style={{
                        // width: "100%",
                        // minWidth: 800,
                        // overflowX: "auto",
                        height: 400,
                      }}
                    >
                      <Bar data={graph2Data} options={options2} />{" "}
                    </div>
                  ) : (
                    <p>No data</p>
                  )}
                </Spin>
              )}
            </div>
          </div>
        </>
      ) : (
        <p></p>
      )}

      {/* <div className="bg-white p-2 rounded-xl mt-8 grid grid-cols-1 md:grid-cols-2 gap-4 place-items-start">
        {banners?.map((i, id) => {
          return (
            <div
              className="bg-primary  relative animate-fade-in  w-full text-center items-center rounded-3xl  "
              key={id}
            >
              <p className="text-bswhite font-semibold text-2xl">{i.title}</p>
              <p className="text-white">{i.subtitle}</p>
              <div>
                <Image
                  src={i.image}
                  height={200}
                  width={500}
                  preview={false}
                  className="rounded-3xl p-4"
                />
              </div>
            </div>
          );
        })}
      </div> */}
    </>
  );
};

export default Dashboard;
